import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useOrg } from "../org";
import { Select } from "./bits";

export const BulkBar = ({ ids, c, archivedView, onDone, onClear }) => {
  const { api } = useOrg();
  const [carers, setCarers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (c.care) api("/caregivers").then((x) => setCarers(x.caregivers || x)).catch(() => {});
    api("/groups").then((gs) => setGroups(gs.filter((g) => g.source === "care"))).catch(() => {});
  }, [api, c.care]);
  const n = ids.length;
  const run = (body, msg) => {
    setBusy(true);
    api("/people/bulk", { method: "POST", body: { person_ids: ids, ...body } })
      .then((r) => { toast.success(`${msg} for ${r.updated} ${r.updated === 1 ? "person" : "people"}`); onDone(); })
      .catch((e) => toast.error(e.message)).finally(() => setBusy(false));
  };
  const sel = "!h-9 !w-auto text-sm";
  return (
    <div className="fixed bottom-20 lg:bottom-6 left-1/2 -translate-x-1/2 z-40 w-[min(960px,calc(100%-24px))] bg-surface border border-line shadow-soft rounded-2xl p-3 flex flex-wrap items-center gap-2" data-testid="bulk-bar">
      <span className="t-body font-medium px-2" data-testid="bulk-count">{n} selected</span>
      {archivedView ? (
        <button disabled={busy || !n} onClick={() => run({ action: "restore" }, "Restored")} className="btn btn-primary btn-sm" data-testid="bulk-restore">Restore to Care</button>
      ) : <>
        {c.care && <button disabled={busy || !n} onClick={() => run({ action: "set_state", care_state: "regular" }, "Set to Regular Care")} className="btn btn-outline btn-sm" data-testid="bulk-regular">Regular Care</button>}
        {c.care && <button disabled={busy || !n} onClick={() => run({ action: "set_state", care_state: "not_monitored" }, "Set to Not Monitored")} className="btn btn-outline btn-sm" data-testid="bulk-not-monitored">Not Monitored</button>}
        {c.care && (
          <Select value="" onChange={(v) => v && run({ action: "assign_caregiver", caregiver_id: v }, "Caregiver assigned")} testid="bulk-caregiver" className={sel}>
            <option value="">Assign Care Leader…</option>
            {carers.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
          </Select>
        )}
        {groups.length > 0 && (
          <Select value="" onChange={(v) => v && run({ action: "add_group", group_id: v }, "Added to group")} testid="bulk-add-group" className={sel}>
            <option value="">Add to group…</option>
            {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
          </Select>
        )}
        {groups.length > 0 && (
          <Select value="" onChange={(v) => v && run({ action: "remove_group", group_id: v }, "Removed from group")} testid="bulk-remove-group" className={sel}>
            <option value="">Remove from group…</option>
            {groups.map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
          </Select>
        )}
        {c.manage && <button disabled={busy || !n} onClick={() => window.confirm(`Archive ${n} ${n === 1 ? "person" : "people"} from Care? Their history is kept and you can restore them from Archived.`) && run({ action: "archive" }, "Archived")} className="btn btn-quiet btn-sm" data-testid="bulk-archive">Archive</button>}
      </>}
      <button onClick={onClear} className="btn btn-quiet btn-sm ml-auto" data-testid="bulk-clear">Done</button>
    </div>
  );
};
